import style from "../../../../assets/scss/common/modal/addChildModal.module.scss";
import React from "react";
import {InitialProfileInfoDTO, ProfileErrorDTO} from "../../../../types/user";
import {useTranslation} from "react-i18next";

interface Args{
    profileInfo: InitialProfileInfoDTO;
    setProfileInfo: React.Dispatch<React.SetStateAction<InitialProfileInfoDTO>>;
    errors: ProfileErrorDTO;
}
export function ChildAgeField({profileInfo, setProfileInfo, errors}:Args) {
    const { t } = useTranslation("profileInfo");
    return (
        <div className={style.infoContainer}>
              <span className={style.infoText}>
                <span className={style.requireText}>
                    {t('profileInfo.addModal.required')}
                </span> {t('profileInfo.addModal.birthday.label')}
              </span>
            <input
                name="birthday"
                value={profileInfo.birthday}
                onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 8);
                    setProfileInfo({...profileInfo, birthday: value});
                }}
                placeholder={t('profileInfo.addModal.birthday.placeholder')}
                className={style.inputField}
            />
            {errors.birthday && <div className={style.errorText}>{errors.birthday}</div>}
        </div>
    )
}